import FieldOptionKeys from 'forms-utils-lib/constants/formField/FieldOptionKeys';
const createFormFieldOption = ({
  value = '',
  label = '',
  displayOrder = 0
}) => ({
  value,
  label,
  displayOrder,
  [FieldOptionKeys.DOUBLE_DATA]: 0,
  [FieldOptionKeys.HIDDEN]: false,
  [FieldOptionKeys.DESCRIPTION]: '',
  [FieldOptionKeys.READ_ONLY]: false
});
export default createFormFieldOption;